import { Text, useMainContext } from '../../../../modules/Dashboard'
import { usePredictContext } from '../../context/PredictContextProvider'
import { useNavigate, useParams } from 'react-router-dom'
import LeftIcon from '../../../../components/icons/Left'
import useFastScans from '../../hooks/useFastScans'

// Icons
import { ReactComponent as Ellipse } from '../../assets/methods/card-ellipse.svg'
import AssistantIcon from '../AssistantIcon'
import LockedAssistant from '../LockedAssistant'
import { useState } from 'react'
import CardLayout from '../../../../components/layouts/CardLayout'

const RenderFastScans = () => {
  const {
    main: { lang },
  } = useMainContext()

  const navigate = useNavigate()
  const { assistant, isLocked } = usePredictContext()
  const [activeTab, setActiveTab] = useState('all')
  const { loading, fastScans } = useFastScans({ market: activeTab })

  const handleSelectAssistant = (method) => {
    if (isLocked) return
    assistant.setAssistant(method)
    navigate(`/analyze/fastscans/${activeTab}?step=tickers`)
  }

  return (
    <CardLayout>
      <div className='flex items-center justify-between mb-4'>
        <Text tid="all-available-agents" className='text-xl !text-[#F3E8FF]' />
        {/* Tabs */}
        <div className="flex gap-2">
          <TabButton
            active={activeTab === 'all'}
            onClick={() => setActiveTab('all')}
            label="All"
          />
          <TabButton
            active={activeTab === 'crypto'}
            onClick={() => setActiveTab('crypto')}
            label="Crypto"
          />
          <TabButton
            active={activeTab === 'forex'}
            onClick={() => setActiveTab('forex')}
            label="Forex"
          />
        </div>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 gap-5 min-h-[150px] max-h-[750px] overflow-y-auto px-2">
        {loading
          ? Array.from({ length: 2 }).map((_, i) => <SkeletonCard key={i} />)
          : fastScans?.map((assistant, index) => (
            <div
              key={`${assistant.value}`}
              onClick={() => handleSelectAssistant(assistant)}
              className="relative overflow-hidden bg-[#1E1533] border border-purpleBorderDark rounded-2xl cursor-pointer transition-all hover:scale-[1.01] group"
            >
              <LockedAssistant />

              <div className="flex items-start gap-2 relative z-[2] h-full p-5">
                <AssistantIcon assistantValue={assistant.value} size={35} />
                <div className="flex flex-col items-start gap-1">
                  <div className='space-x-2'>
                    <Text tid={assistant.label} className="text-lg !text-[#F3E8FF] rtl:font-bold" />
                    <span className='border border-[#AD46FF66] bg-[#AD46FF33] rounded-full px-1 pb-[2px] '>
                      <Text tid={assistant.tickerCase} className="text-xs !text-[#DAB2FF] rtl:font-bold" />
                    </span>
                  </div>
                  <Text tid={assistant.description} className="text-sm text-[#DAB2FFB2]" />
                </div>
                <div className="absolute right-0 top-0 h-full">
                  <Ellipse height="100%" />
                </div>
              </div>
            </div>
          ))}
      </div>
    </CardLayout>
  )
}


export default RenderFastScans


const TabButton = ({ active, onClick, label }) => (
  <button
    onClick={onClick}
    className={`
      px-4 py-2 rounded-xl text-sm font-medium transition-all
      ${active
        ? 'bg-gradient-to-r from-[#AD46FF] to-[#C800DE] text-white'
        : 'border border-[#AD46FF4D] text-[#DAB2FF] hover:text-white'}
    `}
  >
    {label}
  </button>
)


// Skeleton loader
const SkeletonCard = () => (
  <div className="bg-[#262433] rounded-lg p-4 h-[120px] flex flex-col justify-between">
    <div className="animate-pulse h-6 bg-gray-600 rounded w-[35px]"></div>
    <div className="animate-pulse h-4 bg-gray-600 rounded w-[150px] mt-2"></div>
    <div className="animate-pulse h-4 bg-gray-600 rounded w-[300px] mt-2"></div>
  </div>
)
